<template>
  <div class="h-full w-full overflow-auto">
    <DataGetter
      @dataAvailable="
        data => {
          customers = data
          this.isLoading = false
        }
      "
      contentId="customers"
    />
    <div
      class="flex flex-col gap-4"
      v-if="isLoading || customersToShow.length > 0"
    >
      <div
        v-for="(customer, index) in isLoading
          ? shimmerCustomers
          : customersToShow"
        :key="index"
        class="flex items-center justify-between bg-white rounded-2xl ripple"
        :class="{ shimmerElement: customer.shimmer }"
      >
        <div
          class="flex items-center gap-[0.5rem] w-[17rem] min-w-[17rem] text-sm"
        >
          <img
            :src="customer.image"
            class="min-w-[3.5rem] w-[3.5rem] h-[3.5rem] object-cover rounded-full"
          />
          <div class="w-[calc(100%-4rem)]">
            <h3 class="title-color truncate">
              {{ customer.name }}
            </h3>
            <p class="truncate">
              {{ customer.email }}
            </p>
          </div>
        </div>

        <div class="ml-auto text-right">
          <div>
            {{ $Commons.timeFrom(customer.lastOrder, 'DD MMM YYYY') }}
          </div>
          <!-- <div class="py-1"></div> -->
          <div class="title-color">
            {{ $Commons.timestampToDate(customer.lastOrder, 'HH:mm') }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="h-[50vh] w-full flex-col items-center justify-center flex"
      v-else
    >
      <div class="w-1/2">
        <img src="@/assets/images/empty/no-user.png" alt="" />
      </div>
      <div class="py-1"></div>
      <div class="text-center">
        <div class="py-1"></div>
        <div class="text-4xl title-color font-bold">Aucun client</div>
        <div class="py-1"></div>
        <div class="text-lg">
          Pas de client dans votre boutique. <br />
          Vos clients s'afficheront ici.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataGetter from '@/components/utils/DataGetter.vue'
import DotLottieComponent from '../utils/DotLottieComponent.vue'

export default {
  name: 'homeComponent',
  components: { DataGetter, DotLottieComponent },
  data() {
    return {
      eventsIds: [],
      customers: [],
      activeTab: 'home',
      isLoading: true,
      shimmerCustomers: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {},
  methods: {
    addNewProduct() {
      this.$Events.dispatchEvent('new_product_adding_required')
    },
  },
  computed: {
    customersToShow() {
      return this.customers.slice(0, 8)
    },
  },
}
</script>
